var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3034_460710)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8763 4.58116L7.29297 2.61687V13.7828L9.44748 14.86C9.75621 15.0144 9.88135 15.3898 9.72698 15.6985C9.57262 16.0073 9.1972 16.1324 8.88846 15.9781L6.62002 14.8438L2.96247 16.063L2.96243 16.0631C2.01815 16.3778 1.04297 15.6749 1.04297 14.6795V4.68406C1.04297 4.13169 1.35505 3.62672 1.84912 3.37969L1.84913 3.37969L6.04276 1.28287L6.04277 1.28287C6.42645 1.09102 6.87514 1.07785 7.26941 1.24682L7.26942 1.24682L12.6296 3.54403H17.5013C18.3067 3.54403 18.9596 4.19696 18.9596 5.00237V9.5857C18.9596 9.93088 18.6798 10.2107 18.3346 10.2107C17.9895 10.2107 17.7096 9.93088 17.7096 9.5857V5.00237C17.7096 4.8873 17.6164 4.79403 17.5013 4.79403H13.1263V9.5857C13.1263 9.93088 12.8465 10.2107 12.5013 10.2107C12.1561 10.2107 11.8763 9.93088 11.8763 9.5857V4.58116ZM6.04297 2.68031V13.7186L2.56722 14.8772L2.56718 14.8772C2.43226 14.9221 2.29297 14.8217 2.29297 14.6795V4.68406C2.29297 4.60515 2.33755 4.53302 2.40813 4.49773L2.40814 4.49773L6.04297 2.68031ZM14.668 11.044C12.666 11.044 11.043 12.667 11.043 14.669C11.043 16.671 12.666 18.294 14.668 18.294C15.4433 18.294 16.1617 18.0506 16.7511 17.6361L17.8927 18.7776C18.1368 19.0217 18.5325 19.0217 18.7766 18.7776C19.0207 18.5336 19.0207 18.1378 18.7766 17.8938L17.635 16.7522C18.0496 16.1628 18.293 15.4443 18.293 14.669C18.293 12.667 16.67 11.044 14.668 11.044ZM12.293 14.669C12.293 13.3574 13.3563 12.294 14.668 12.294C15.9796 12.294 17.043 13.3574 17.043 14.669C17.043 15.9807 15.9796 17.044 14.668 17.044C13.3563 17.044 12.293 15.9807 12.293 14.669Z",
    fill: "#76B72A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3034_460710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiscover);
export default __webpack_public_path__ + "static/media/ic-discover.5df8a33771e167454e36b719172c87e9.svg";
export { ForwardRef as ReactComponent };